// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.atpl-intro-wrapper {
  max-width: 390px;
  /* min-height: 100vh; */
  margin: auto;
  /* height: 80vh; */
  overflow-y: hidden;
  overflow-x: hidden;
}

.atpl-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: Poppins;

  overflow-y: hidden;
  /* justify-content: center;
  padding: 20px 10px; */
  padding: 20px 10px 10px 10px;
}

.atpl-default-css-config {
  --atplGreyColor: rgb(183,184,188); /* Primary button color */

}
`, "",{"version":3,"sources":["webpack://./src/pages/AtpLab/atplGlobal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;;EAEpB,kBAAkB;EAClB;uBACqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC,EAAE,yBAAyB;;AAE9D","sourcesContent":[".atpl-intro-wrapper {\n  max-width: 390px;\n  /* min-height: 100vh; */\n  margin: auto;\n  /* height: 80vh; */\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n\n.atpl-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  font-family: Poppins;\n\n  overflow-y: hidden;\n  /* justify-content: center;\n  padding: 20px 10px; */\n  padding: 20px 10px 10px 10px;\n}\n\n.atpl-default-css-config {\n  --atplGreyColor: rgb(183,184,188); /* Primary button color */\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
